import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        background: '#141329',
        padding: '48px 96px',
        [theme.breakpoints.up('lg')]: {
            paddingTop: 72,
            paddingBottom: 72
        },
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px 24px 48px 24px',
        }
    },
    leftSection: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        [theme.breakpoints.up('md')]: {
            // paddingRight: '60px',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            paddingRight: 90,
        },
    },
    title: {
        margin: 0,
        fontSize: '48px',
        fontWeight: '800',
        color: '#fff',
        // maxWidth: 537,
        [theme.breakpoints.down('md')]: {
            fontSize: '30px',
            lineHeight: '36px',
            textAlign: 'center',
        }
    },
    rightSection: {
        [theme.breakpoints.up('md')]: {
            width: '55%',
        }
    },
    faqContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0',
    },
    faqItem: {
        borderBottom: '1px solid #333',
        '&:last-child': {
            borderBottom: 'none',
        }
    },
    faqHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '24px 0',
        cursor: 'pointer',
        gap: '16px',
        transition: 'all 0.3s ease',
        [theme.breakpoints.up('lg')]: {
            gap: '20px'
        },
        '&:hover': {
            opacity: 0.8,
        }
    },
    questionIcon: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        background: '#403DE3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& > span': {
            color: '#fff',
            fontSize: '18px',
            fontWeight: '900',
            [theme.breakpoints.up('lg')]: {
                fontSize: '24px',
            }
        },
        [theme.breakpoints.up('lg')]: {
            width: '40px',
            height: '40px',
        },
        [theme.breakpoints.down('md')]: {
            width: '32px',
            height: '32px',
            '& > span': {
                fontSize: '18px',
            }
        }
    },
    questionText: {
        flex: '1',
        fontSize: '20px',
        fontWeight: '800',
        color: '#D1D5DB',
        [theme.breakpoints.down('md')]: {
            fontSize: '18px',
        },
        '&:hover': {
            color: '#fff',
        }
    },
    chevronIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        transition: 'transform 0.3s ease',
    },
    faqAnswer: {
        padding: '0 0 24px 48px',
        fontSize: '18px',
        fontWeight: '400',
        color: '#E5E7EB',
        lineHeight: '1.6',
        whiteSpace: 'pre-line',
        animation: '$slideDown 0.3s ease-out',
        [theme.breakpoints.up('lg')]: {
            lineHeight: '32px'
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '16px',
        }
    },
    faqLink: {
        color: '#1B7AED',
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
            color: '#3b51fc',
        }
    },
    '@keyframes slideDown': {
        '0%': {
            opacity: 0,
            transform: 'translateY(-10px)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        }
    },
    txtWhite: {
        color: '#fff',
    }
}));

export default useStyles;
